import React from "react";

import { withRouter } from "react-router";

import AdminService from "../../../services/admin/AdminService";

import AdminPage from "../common/AdminPage";
import Subscriptions from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/subscriptions/Subscriptions";

const SubscriptionValidationPage = ({ history }) => {
  return (
    <AdminPage showGoBackLink={true} history={history}>
      <Subscriptions
        loadCNumber={AdminService.getCNumber}
        loadActiveDepartments={AdminService.getStores}
        loadValidateSubscription={AdminService.validateSubscription}
      />
    </AdminPage>
  );
};

export default withRouter(SubscriptionValidationPage);
